<template>
  <FormKit
    type="form"
    name="Kontakt-B2C"
    id="Kontakt-B2C"
    :incomplete-message="false"
    :actions="false"
    @submit="submitContactB2C"
    #default="{ state: { valid } }"
    form-class="dbc-formkit-form"
  >
    <div class="dbc-formkit-form-inner">
      <div>
        <FormKit
          type="dbcText"
          name="name"
          :label="$t('dbc-contact-b2c-input-name-label')"
          :placeholder="$t('dbc-contact-b2c-input-name-placeholder')"
          validation="required"
        />
        <FormKit
          type="dbcEmail"
          name="mail"
          :label="$t('dbc-contact-b2c-input-email-label')"
          validation="required|email"
          :validation-messages="{
            email: $t('dbc-error-email-validation'),
          }"
          :placeholder="$t('dbc-contact-b2c-input-email-placeholder')"
        />
        <FormKit
          id="topic"
          v-model="topic"
          type="select"
          :label="$t('dbc-contact-b2c-select-topic-label')"
          :placeholder="`- ${$t('dbc-contact-b2c-select-topic-placeholder')} -`"
          validation="required"
          name="topic"
          :options="topicOptions"
        />
      </div>
      <div>
        <FormKit
          type="textarea"
          name="message"
          :label="$t('dbc-contact-b2c-textarea-message-label')"
          rows="10"
          validation="required"
          :placeholder="$t('dbc-contact-b2c-textarea-message-placeholder')"
        />
      </div>
    </div>

    <UtilityText
      v-if="errorCode !== ''"
      class="dbc-u-error-txt"
      :text="$t(errorCode)"
    />

    <FormsOmqContainer />

    <FormKit
      type="submit"
      :label="$t('dbc-contact-button-submit')"
      :loading="isLoading"
      :disabled="!valid || isLoading"
      input-class="!w-[128px]"
    />
  </FormKit>
</template>

<script setup lang="ts">
import { getNode } from '@formkit/core'

defineProps<{
  isLoading: boolean
  errorCode: string
}>()

const emit = defineEmits<{
  (e: 'onSubmitContactZnuny', formData: ContactFormData): void
}>()

function submitContactB2C(formData: ContactFormData) {
  emit('onSubmitContactZnuny', {
    ...formData,
    topic: topic.value?.label || '',
    type: 'b2c',
  })
}

const { t } = useI18n()
const route = useRoute()
const topic = ref<RadioOption | null>(null)

const topicOptions = ref<RadioOption[]>([
  { value: 'invoice', label: t('dbc-contact-b2c-select-topic-option-invoice') },
  {
    value: 'blocked-contract',
    label: t('dbc-contact-b2c-select-topic-option-blocked-contract'),
  },
  {
    value: 'tariff-change',
    label: t('dbc-contact-b2c-select-topic-option-tariff-change'),
  },
  { value: 'request', label: t('dbc-contact-b2c-select-topic-option-request') },
])

onMounted(() => {
  const node = getNode('topic')
  if (route.query.topic && typeof route.query.topic === 'string') {
    topic.value =
      topicOptions.value.find((option) => option.value === route.query.topic) ||
      null

    node?.input(topic.value?.value || '', false)
  }
})
</script>
